import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, shareReplay, tap, catchError } from 'rxjs';

const TREE_KEY = 'sb_category_tree_v1';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  private API =
    'https://superbangladesh-api-1.onrender.com/api/categories';

  // একবার এনে মেমরিতে রাখা হয় — সাইডবার, ক্যাটাগরি পেজ সবাই একই কপি পায়
  private tree: any[] | null = null;
  private tree$: Observable<any[]> | null = null;

  constructor(
    private http: HttpClient
  ) {
    this.tree = this.readStored();

    // আগের সেশনের কপি থাকলে সেটা দিয়ে সাথে সাথে দেখানো হয়,
    // আর পেছনে চুপচাপ নতুন কপি এনে বদলে দেওয়া হয়
    if (this.tree && typeof window !== 'undefined') {
      setTimeout(() => this.refreshTree(), 1500);
    }
  }

  private readStored(): any[] | null {
    try {
      if (typeof sessionStorage === 'undefined') return null;
      const raw = sessionStorage.getItem(TREE_KEY);
      const parsed = raw ? JSON.parse(raw) : null;
      return Array.isArray(parsed) && parsed.length ? parsed : null;
    } catch {
      return null;
    }
  }

  private store(tree: any[]): void {
    try {
      if (typeof sessionStorage === 'undefined') return;
      sessionStorage.setItem(TREE_KEY, JSON.stringify(tree));
    } catch { /* storage full / blocked — ignore */ }
  }

  // আগে থেকে মেমরিতে থাকলে সাথে সাথে পাওয়া যায় (নেটওয়ার্ক ছাড়া)
  getCachedTree(): any[] | null {
    return this.tree;
  }

  // 🔥 CATEGORY TREE
  // - একই সময়ে অনেকে চাইলেও একটাই HTTP কল যায়
  // - cache থাকলে সাথে সাথে সেটা দেয়, ব্যাকগ্রাউন্ডে নতুন করে আনে না
  //   (force=true দিলে নতুন করে আনে)
  getTree(force = false): Observable<any[]> {

    if (!force && this.tree) {
      return of(this.tree);
    }

    if (!this.tree$ || force) {
      this.tree$ = this.http
        .get<any[]>(this.API + '/tree')
        .pipe(
          tap(res => {
            const list = Array.isArray(res) ? res : [];
            this.tree = list;
            this.store(list);
          }),
          catchError(err => {
            this.tree$ = null;
            throw err;
          }),
          shareReplay(1)
        );
    }

    return this.tree$;
  }

  // ব্যাকগ্রাউন্ডে চুপচাপ নতুন ডাটা আনে (সাইট খুললে একবার)
  refreshTree(): void {
    this.getTree(true).subscribe({ error: () => {} });
  }

  // 🔥 MAIN CATEGORY

  getMain() {

    return this.http.get<any[]>(
      this.API
    );
  }


  // 🔥 CHILD CATEGORY

  getChildren(id: number) {

    return this.http.get<any[]>(
      `${this.API}/${id}/children`
    );
  }


  // 🔥 POPULAR CATEGORIES
  // ADMIN PANEL থেকে selected category আসবে

  getPopular() {

    return this.http.get<any[]>(
      `${this.API}/popular`
    );
  }

}